import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[mdButtonSpinner]',
})
export class ButtonSpinnerDirective implements AfterViewInit, OnChanges {
  @Input('mdButtonSpinner') showSpinner: boolean | null = true;
  @Input('mdButtonSpinnerColor') color = 'white';
  spinner: HTMLDivElement = this.document.createElement('div');
  spinnerTemplate = `<i class="loader-spin loader-spin-inherit-border-color" style='margin-right: 8px;'> </i>`;
  defaultClassList = 'button__icon';

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: { createElement: (arg0: string) => any },
  ) {}

  ngAfterViewInit() {
    this.renderer.setAttribute(this.spinner, 'class', this.defaultClassList);
    this.spinner.innerHTML = '';
    this.renderer.insertBefore(
      this.elementRef.nativeElement,
      this.spinner,
      this.elementRef.nativeElement.firstChild,
    );
    this.updateColor();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.color) {
      this.updateColor();
    }

    if (this.spinner && this.elementRef) {
      this.toggleVisibility();
    }
  }

  toggleVisibility() {
    if (this.showSpinner) {
      this.spinner.innerHTML = this.spinnerTemplate;
      this.renderer.setStyle(this.elementRef.nativeElement, 'pointer-events', 'none');
    } else {
      this.spinner.innerHTML = '';
      this.renderer.removeStyle(this.elementRef.nativeElement, 'pointer-events');
    }
  }

  private updateColor(): void {
    this.renderer.setStyle(this.spinner, 'border-color', this.color);
  }
}
